import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import appSettings from '../../app/reducers/app-settings';
import auth from '../../app/reducers/auth';
import communitiesContext from '../../app/reducers/communities-context';
import experiments from '../../app/reducers/experiments';
import { appDataReducer, tpaSettingsReducer } from '@wix/communities-blog-client-common';
import isDemoMode from '../../app/reducers/is-demo-mode';
import isLoaded from '../../app/reducers/is-loaded';
import isLoading from '../../app/reducers/is-loading';
import message from '../../app/reducers/message';
import modal from '../../app/reducers/modal';
import pagination from '../../app/reducers/pagination';
import posts from '../../app/reducers/posts';
import siteInfo from '../../app/reducers/site-info';
import sitePages from '../../app/reducers/site-pages';
import categories from '../../app/reducers/categories';
import users from '../../app/reducers/users';
import viewMode from '../../app/reducers/view-mode';
import searchParams from '../../app/reducers/search-params';
import customRoutes from '../../app/store/custom-routes/custom-routes-reducer';

export default combineReducers({
  appSettings,
  auth,
  communitiesContext,
  experiments,
  appData: appDataReducer,
  isDemoMode,
  isLoaded,
  isLoading,
  message,
  modal,
  pagination,
  posts,
  routing: routerReducer,
  siteInfo,
  sitePages,
  categories,
  users,
  viewMode,
  searchParams,
  tpaSettings: tpaSettingsReducer,
  customRoutes,
});
